/**
 * @generated SignedSource<<c78434a9297abdf0132d72ee9d4de479>>
 * @relayHash ebcfefacb7fe243c0159b2b35aec9902
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83eeceaf5a2b8b41c5852f2ee89d342c3f950765d131d3763a939bf14dad1807

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareHarmonisedTimelineEmbedQuery } from './JiraSoftwareHarmonisedTimelineEmbedQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareHarmonisedTimelineEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "83eeceaf5a2b8b41c5852f2ee89d342c3f950765d131d3763a939bf14dad1807",
    "metadata": {},
    "name": "JiraSoftwareHarmonisedTimelineEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
